import axios from "axios";

//开发环境
// axios.defaults.baseURL = "http://47.103.40.97:8080"; //43.143.197.79

//  测试环境
// axios.defaults.baseURL = "http://121.36.212.127:10010"; //43.143.197.79

//线上环境
// axios.defaults.baseURL = "http://121.36.212.127:10000";//43.143.197.79
axios.defaults.baseURL = "https://www.ohdt.top/prod-api/";

export default axios;



// WEBPACK FOOTER //
// ./src/request/axios.js